module.exports = __webpack_public_path__ + "assets/img/starter_v_show.1f505df4.jpg";